import dayjs from '../../utils/dayjs';

import helpers from 'helpers/index';
import Pagination from 'components/pagination';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  ENUM_TRANSACTION_PAYMENT_METHOD,
  ENUM_TRANSACTION_STATUS,
  TypedTransactionAnalytics,
  TypedTransactions,
  useDownloadTransactions,
  useGetTransactions,
} from 'queries/transactions.query';
import { Helmet } from 'react-helmet-async';
import {
  Badge,
  BlockStack,
  Box,
  Button,
  Card,
  Checkbox,
  DataTable,
  FormLayout,
  Icon,
  InlineStack,
  Link,
  Modal,
  Page,
  SkeletonBodyText,
  Text,
  TextField,
  Tooltip,
} from '@shopify/polaris';
import { ___ } from 'languages/index';
import { BillFilledIcon, CashDollarFilledIcon, FaviconIcon } from '@shopify/polaris-icons';
import TransactionFilter from './filter';
import TransactionModal from './transaction.modal';
// import DateRangePicker from 'components/dateRangePicker';
import { PageDownIcon } from '@shopify/polaris-icons';
import DebitClearModal from './debit_clear.modal';
import RefundModal from './refund.modal';
import { useAuth } from 'context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateLeft, faBackspace, faBackward, faEllipsis, faLink, faListAlt } from '@fortawesome/free-solid-svg-icons';

export default function Transactions() {
  const rootSearchPath = window.location.search;
  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  // const { start, end } = helpers.getDayRange(new Date());
  let StringQuery: any = helpers.ExtractUrl(rootSearchPath) || false;
  const initialQuery = {
    query: '',
    page: 1,
    limit: 200,
    casher: '',
    // createdAt: `lte:${end},gte:${start}`,
    createdAt: ``,
    sort: 'createdAt:desc',
  };

  const [mainQuery, setMainQuery] = useState<any>({
    ...initialQuery,
    ...StringQuery,
  });

  // const [defaultDate, setDefaultDate] = useState<{ startDate: string; endDate: string }>({
  //   startDate: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
  //   endDate: dayjs(new Date()).format('YYYY-MM-DD 23:59:59'),
  // });

  // useEffect(() => {
  //   let fromTimeStamp = new Date(defaultDate.startDate).getTime();
  //   let toTimeStamp = new Date(defaultDate.endDate).getTime();
  //   setMainQuery((prevMainQuery) => ({ ...prevMainQuery, payment_method: '', createdAt: `lte:${toTimeStamp},gte:${fromTimeStamp}` }));
  // }, [defaultDate]);

  // const dateChangeCallback = useCallback((_e) => {
  //   let { since, until } = _e.period;
  //   let FNS = {
  //     startDate: '',
  //     endDate: '',
  //   };
  //   if (since) {
  //     FNS.startDate = new Date(dayjs(since).format('YYYY-MM-DD 00:00:00')).toISOString();
  //   }
  //   if (until) {
  //     FNS.endDate = new Date(dayjs(until).format('YYYY-MM-DD 23:59:59')).toISOString();
  //   }
  //   setDefaultDate(FNS);
  // }, []);

  const { refetch: getEntities, data, isFetching: loading } = useGetTransactions(mainQuery);

  const [entities, setEntities] = useState<TypedTransactions[]>([]);
  const [selectedTransactionIds, setSelectedTransactionIds] = useState<string[]>([]);
  const [showBulkDebtModal, setShowBulkDebtModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [analyticsData, setAnalyticsData] = useState<TypedTransactionAnalytics>(null);
  const [totalItems, setTotalItems] = useState(0);
  useEffect(() => {
    if (data) {
      let { transactions, analytics, totalItems } = data;
      setEntities(transactions);
      setSelectedTransactionIds((currentIds) =>
        currentIds.filter((id) => transactions.some((transaction) => transaction.id === id && !transaction.refunded_at))
      );
      setAnalyticsData(analytics);
      setTotalItems(totalItems);
    }
  }, [data]);
  /**
   * Change page number
   * Must be mainQuery or it will reset mainQuery. BUG!
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  const reduceRequest = useCallback((mainQuery) => {
    getEntities();
    return mainQuery;
  }, []);

  const reduceRequestMemo = useMemo(() => {
    return helpers.debounce((_value) => {
      reduceRequest?.call(this, _value);
    }, 500);
  }, []);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (window.location.search !== buildURLSearch) {
      window.history.replaceState(null, 'Transactions', '/transactions' + buildURLSearch);
    }
    reduceRequestMemo(mainQuery);
  }, [mainQuery]);

  /******** KHỐI PHÁT HIỆN MOBILE */
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 800px)');
    const handleChange = (event: MediaQueryListEvent | MediaQueryList) => {
      const matches = 'matches' in event ? event.matches : mediaQuery.matches;
      setIsMobile(matches);
    };

    handleChange(mediaQuery);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange as (event: MediaQueryListEvent) => void);
    } else {
      mediaQuery.addListener(handleChange as (event: MediaQueryListEvent) => void);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange as (event: MediaQueryListEvent) => void);
      } else {
        mediaQuery.removeListener(handleChange as (event: MediaQueryListEvent) => void);
      }
    };
  }, []);

  /** Gán một giao dịch nào đó vào vé nào đó */
  const currentTransactionForAssign = useRef(null);
  const [showModalEditTransaction, setShowModalEditTransaction] = useState(false);

  const debtPaymentMethods = useMemo(
    () => [ENUM_TRANSACTION_PAYMENT_METHOD.DEBT_CUSTOMER, ENUM_TRANSACTION_PAYMENT_METHOD.DEBT_AGENT, ENUM_TRANSACTION_PAYMENT_METHOD.THIRD_PARTY],
    []
  );

  const selectableTransactions = useMemo(() => entities.filter((transaction) => transaction.id && !transaction.refunded_at), [entities]);

  const isAllTransactionsSelected =
    selectableTransactions.length > 0 &&
    selectableTransactions.every((transaction) => Boolean(transaction.id && selectedTransactionIds.includes(transaction.id)));

  const canClearSelectedDebt =
    selectedTransactionIds.length > 0 &&
    selectedTransactionIds.every((id) => {
      const transaction = entities.find((entity) => entity.id === id);
      return Boolean(transaction?.payment_method && debtPaymentMethods.includes(transaction.payment_method));
    });

  const toggleSelectAllDebtTransactions = useCallback(
    (checked: boolean) => {
      const visibleTransactionIds = selectableTransactions.reduce<string[]>((ids, transaction) => {
        if (transaction.id) {
          ids.push(transaction.id);
        }
        return ids;
      }, []);
      setSelectedTransactionIds((currentIds) => {
        if (checked) {
          return Array.from(new Set([...currentIds, ...visibleTransactionIds]));
        }

        return currentIds.filter((id) => !visibleTransactionIds.includes(id));
      });
    },
    [selectableTransactions]
  );

  const toggleSelectDebtTransaction = useCallback((transactionId: string, checked: boolean) => {
    setSelectedTransactionIds((currentIds) => {
      if (checked) {
        return currentIds.includes(transactionId) ? currentIds : [...currentIds, transactionId];
      }

      return currentIds.filter((id) => id !== transactionId);
    });
  }, []);

  /** Mở cái modal gạt nợ */
  const openBulkDebtModal = useCallback(() => {
    setShowBulkDebtModal(true);
  }, []);

  const { mutateAsync: downloadExcelThisFilter, isPending: downloadGenerating } = useDownloadTransactions();
  const generateDownloadLink = useCallback(async () => {
    try {
      const blob = await downloadExcelThisFilter(mainQuery);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = 'transactions.xlsx';

      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (e) {}
  }, [mainQuery]);

  const { currentUserCan } = useAuth();

  return (
    <>
      <Helmet>
        <title>Danh sách giao dịch</title>
      </Helmet>
      <Page
        title="Danh sách giao dịch"
        fullWidth
        primaryAction={{
          loading: downloadGenerating,
          icon: PageDownIcon,
          content: 'Download bản này',
          onAction: () => {
            generateDownloadLink();
          },
          disabled: !currentUserCan('download_transactions'),
        }}
      >
        <BlockStack gap="400">
          {/* <DateRangePicker onChange={dateChangeCallback} Alignment="left" DefaultDateIndex={0} /> */}

          <Text as="p" tone="success">
            Trong các kết quả này
          </Text>
          <InlineStack gap={isMobile ? '200' : '400'} wrap>
            <Box minWidth={isMobile ? '100%' : '200px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={CashDollarFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Tiền mặt
                    </Text>
                  </InlineStack>
                  {loading ? (
                    <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                      <SkeletonBodyText lines={2} />
                    </Text>
                  ) : (
                    <>
                      <Text variant="headingLg" as="p">
                        {helpers.formatNumberWithCommas(analyticsData?.sum.CASH)} VND
                      </Text>
                      <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                        Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.CASH)} giao dịch
                      </Text>
                    </>
                  )}
                </BlockStack>
              </Card>
            </Box>
            <Box minWidth={isMobile ? '100%' : '200px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Chuyển khoản
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.BANK)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.BANK)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
            <Box minWidth={isMobile ? '100%' : '200px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300" background="bg-fill-caution">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Công nợ khách
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.DEBT_CUSTOMER)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.DEBT_CUSTOMER)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
            <Box minWidth={isMobile ? '100%' : '200px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300" background="bg-fill-caution">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Công nợ đại lý
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.DEBT_AGENT)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.DEBT_AGENT)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
            <Box minWidth={isMobile ? '100%' : '200px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300" background="bg-fill-caution">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Công nợ bên thứ ba
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.THIRD_PARTY)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.THIRD_PARTY)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
            <Box>
              <Card padding="300" background="bg-fill-warning">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Hoàn tiền
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.REFUND)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.REFUND)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
          </InlineStack>
        </BlockStack>
        <br />
        <Card padding="0">
          <TransactionFilter onCallback={filterCallback} loading={loading} />
          <Box padding="400" borderBlockEndWidth="025" borderColor="border">
            <InlineStack align="space-between" blockAlign="center" gap="300" wrap>
              <Text as="p" tone="subdued">
                Đã chọn {selectedTransactionIds.length} giao dịch
              </Text>
              <InlineStack gap="200">
                <Button disabled={!canClearSelectedDebt} onClick={openBulkDebtModal}>
                  Gạt nợ công nợ
                </Button>
                <Button variant="primary" disabled={selectedTransactionIds.length === 0} onClick={() => setShowRefundModal(true)} tone="critical">
                  Hoàn tiền
                </Button>
              </InlineStack>
            </InlineStack>
          </Box>
          <DataTable
            verticalAlign="middle"
            hideScrollIndicator={true}
            stickyHeader
            increasedTableDensity
            columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text']}
            headings={[
              <Checkbox
                label="Chọn tất cả giao dịch đang hiển thị"
                labelHidden
                checked={isAllTransactionsSelected}
                disabled={selectableTransactions.length === 0}
                onChange={toggleSelectAllDebtTransactions}
              />,
              'ID',
              'QR?',
              'Refund?',
              'Số tiền',
              'Phương thức',
              'Nội dung',
              'Đơn hàng',
              'H.đơn',
              'Ngày đi',
              'Xe',
              'Tài xế',
              'Người thu tiền',
              'Ngày thanh toán',
              'Ngày gạt nợ',
              'Ghi chú gạt nợ',
              'Người gạt nợ',
            ]}
            rows={
              entities?.map((transaction) => {
                const {
                  id,
                  order_id,
                  order_data,
                  amount,
                  payment_method,
                  payment_status,
                  description,
                  casher_data,
                  createdAt,
                  is_from_qr,
                  vehicle_data,
                  driver_data,
                  debt_clear_note,
                  debt_cleared_at,
                  debt_cleared_by,
                  debt_clearer,
                  refund_by,
                  refund_note,
                  refunded_at,
                  refunder_data,
                  invoices,
                } = transaction;
                // let trip_hour = dayjs(new Date(Number(order_data?.departure_date))).format('HH:mm');
                let trip_date_reformat = dayjs(new Date(Number(order_data?.departure_date))).format('YYYY-MM-DD');
                let journey_id = order_data?.journey_id;

                let order_link = null;
                if (order_data) {
                  order_link = (
                    <>
                      <Link
                        url={`/ticket_managers?d=${trip_date_reformat}&journey_id=${journey_id}&h=${order_data?.trip_manifest?.time_id}#${order_id}`}
                      >{`${order_data?.order_code}`}</Link>
                      &nbsp;
                      <Tooltip content={'Chuyển sang đơn hàng khác'}>
                        <Link
                          onClick={() => {
                            currentTransactionForAssign.current = id;
                            setShowModalEditTransaction(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faEllipsis} />
                        </Link>
                      </Tooltip>
                    </>
                  );
                }

                const canSelectTransaction = Boolean(id && !transaction.refunded_at);

                return [
                  <Checkbox
                    label={`Chọn giao dịch ${id}`}
                    labelHidden
                    checked={id ? selectedTransactionIds.includes(id) : false}
                    disabled={!canSelectTransaction}
                    onChange={(checked) => id && toggleSelectDebtTransaction(id, checked)}
                  />,
                  id,
                  is_from_qr ? '✅' : '',
                  payment_status === ENUM_TRANSACTION_STATUS.REFUND ? (
                    <Tooltip
                      content={`Refund lúc ${dayjs(Number(refunded_at)).utcOffset(7).format('HH:mm DD/MM/YYYY')} bởi ${refunder_data?.display_name}`}
                    >
                      <FontAwesomeIcon color="#a00035" icon={faArrowRotateLeft} />
                    </Tooltip>
                  ) : (
                    ''
                  ),
                  helpers.formatNumberWithCommas(amount),
                  <Badge tone={payment_method === 'CASH' ? 'enabled' : 'attention'}>{payment_method}</Badge>,
                  description,
                  order_link || (
                    <Tooltip content={'Gắn nó vào một đơn hàng'}>
                      <Link
                        onClick={() => {
                          currentTransactionForAssign.current = id;
                          setShowModalEditTransaction(true);
                        }}
                      >
                        ------
                      </Link>
                    </Tooltip>
                  ),
                  invoices?.shDon ?? '',

                  order_data?.departure_date ? dayjs(new Date(Number(order_data?.departure_date))).format('HH:mm DD/MM/YYYY') : '--',
                  vehicle_data?.license_plate || '-',
                  driver_data?.display_name || '-',
                  casher_data?.display_name || '-',
                  <Text as="p" tone="subdued">
                    {dayjs(new Date(Number(createdAt))).format('HH:mm DD-MM-YYYY')}
                  </Text>,

                  debt_cleared_at ? (
                    <Text as="p" tone="subdued">
                      {dayjs(new Date(Number(createdAt))).format('HH:mm DD-MM-YYYY')}
                    </Text>
                  ) : (
                    '--'
                  ),

                  debt_clear_note ? (
                    <Text as="p" tone="subdued">
                      {debt_clear_note}
                    </Text>
                  ) : (
                    '--'
                  ),

                  debt_cleared_by ? debt_clearer?.display_name : '--',
                ];
              }) || []
            }
            footerContent={___('Show page {display_page_number} of {total_record_number} results', {
              display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
              total_record_number: <Text as="strong">{totalItems}</Text>,
            })}
          />
        </Card>

        <br />
        {totalItems > 0 ? (
          <Pagination
            TotalRecord={totalItems}
            onChange={onChangePagination}
            pageSize={Number(mainQuery?.limit)}
            activeCurrentPage={Number(mainQuery?.page)}
          />
        ) : null}
      </Page>
      <br />
      <br />
      <br />
      <br />

      <TransactionModal
        currentTransaction={currentTransactionForAssign.current}
        show={showModalEditTransaction}
        onClose={() => {
          currentTransactionForAssign.current = null;
          setShowModalEditTransaction(false);
        }}
      />

      <DebitClearModal
        show={showBulkDebtModal}
        transactionsID={selectedTransactionIds}
        onClose={() => {
          setShowBulkDebtModal(false);
          setSelectedTransactionIds([]);
        }}
      />
      <RefundModal
        show={showRefundModal}
        transactionsID={selectedTransactionIds}
        onClose={() => {
          setShowRefundModal(false);
          setSelectedTransactionIds([]);
        }}
      />
    </>
  );
}

